import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addShortlink } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';

const useAddShortLink = () => {
    const entityUpdater = useEntityQueryUpdate();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationKey: 'add_shortlink',
        mutationFn: (model) => addShortlink(model),
        onSuccess: (data) => {
            entityUpdater([['short_links'], ['short_link', data.id]], data);
            queryClient.invalidateQueries({
                queryKey: ['short_link', data.id],
                exact: true,
            });
            notifications.show({
                title: 'Success',
                message: 'Successfully registered domain',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useAddShortLink;
